export function buildBasicSections(targetItems = [], nativeItems = [], pronunciations = {}) {
  const nativeByKey = new Map(nativeItems.map((item) => [item.key, item]));
  const sections = new Map();

  targetItems.forEach((item) => {
    const heading = item.category || 'Essentials';
    const nativeItem = nativeByKey.get(item.key);
    const section = sections.get(heading) || {
      heading,
      nativeHeading: '',
      items: [],
    };
    if (!section.nativeHeading && nativeItem?.category) {
      section.nativeHeading = nativeItem.category;
    }
    section.items.push({
      key: item.key,
      targetText: item.text,
      nativeText: nativeItem?.text || String(item.key || '').replaceAll('_', ' '),
      pronunciation: pronunciations[item.id]?.trim() || null,
    });
    sections.set(heading, section);
  });

  return [...sections.values()];
}
